import { useField, useFormikContext } from 'formik'
import React from 'react'

import FieldError from '@/components/form/FieldError'
import FieldLabel from '@/components/form/FieldLabel'
import SelectUserCompany, {
  CompanyOption,
  SelectUserCompanyProps,
} from '@/components/select/SelectUserCompany'

type Props = Omit<SelectUserCompanyProps, 'onChange'> & {
  label?: string
  name: string
  transformValue?: (value: CompanyOption) => unknown
}

const SelectUserCompanyInput: React.FC<Props> = ({
  label,
  name,
  transformValue,
  ...props
}) => {
  const { setFieldValue, submitCount } = useFormikContext()
  const [field, { error }] = useField<CompanyOption | null>(name)
  const id = `field_${name}`
  const showError = !!(submitCount > 0 && error)

  return (
    <>
      {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}

      <SelectUserCompany
        {...props}
        onChange={(option) => {
          const value =
            option && transformValue ? transformValue(option) : option
          setFieldValue(field.name, value)
        }}
      />

      {showError && <FieldError inputId={id}>{error}</FieldError>}
    </>
  )
}

export default SelectUserCompanyInput
